import React, { Component } from 'react';
import './offline-tooltip.css';

export default class OfflineTooltip extends Component {
  render() {
    return <div className="rdp-react-template-component-offline-tooltip">
      <span className="rdp-react-template-component-offline-tooltip-icon"></span>
      <p className="rdp-react-template-component-offline-tooltip-message">Você está navegando offline.</p>
    </div>
  }
}
